import landlineMask from './landline';
import mobileMask from './mobile';

// (00) 0000-0000
// (00) 90000-0000
// 00000-0000 // TODO: allow mobile without area code
// 0000-0000
// 000000
const mask = function (value) {
    const sanitized = value.replace(/\D/g, '');

    if ((sanitized.length > 8) && (+sanitized[2] === 9)) {
        return mobileMask.mask;
    }

    if (sanitized.length > 8) {
        return landlineMask.mask;
    }

    if (sanitized.length > 7) {
        return [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }

    return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
};

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
